export default __webpack_public_path__ + "static/media/hypercube.a37d9191.png";